import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import CheckBox from "./checkBox";

interface IProps {
  data: string[];
  setData: (data: string[]) => void;
}
const GraphLabelFilter = ({ data, setData }: IProps) => {
  const labels = ["Spotify", "Apple Music", "Deezer", "Amazon", "Youtube"];
  return (
    <Container>
      {labels?.map((label, i) => {
        return (
          <LabelItem key={i}>
            <CheckBox
              Label={label}
              active={data.includes(label)}
              data={data}
              setData={(data) => setData(data)}
            />
            <Typography color={Colors.grey300}>{label}</Typography>
          </LabelItem>
        );
      })}
    </Container>
  );
};

export default GraphLabelFilter;

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;
  flex-wrap: wrap;
`;

const LabelItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;
